import {
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Button,
  DialogActions,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  Collapse,
  Tooltip,
  Typography,
  Badge,
} from "@mui/material";
import React, { useMemo, useRef, useState } from "react";
import palette from "../../../../../../config/colorPalette";
import { clone, isEmpty, isNil } from "ramda";
import { handleChannelDisability } from "../utils";
import { getMuiTheme } from "../../../../../utils/utils";
import { MapContainer, Marker, Polyline, TileLayer, useMap } from "react-leaflet";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ErrorText } from "../styled";

const ModalChannelInfo = ({
  e,
  indChan,
  equipment,
  setEquipment,
  channelPK,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  zoneSubToggle,
  setZoneSubToggle,
  channelNameAsignToggle,
  channelDataToggle,
  setChannelDataToggle,
  zones,
  setZones,
  zoneToggle,
  setZoneToggle,
  setChannelNameAsignToggle,
  channelAsignToggle,
  setChannelAsignToggle,
  thresholdsRanges,
  indexEquipment,
  polylineDisplay,
  useStyles,
  setChannelPK,
  setThresholdsRanges,
  polylineColors,
  hoveredPolylineIndex,
  setHoveredPolylineIndex,
  moreSubsAllowed,
  centroid,
  customCentroidIcon,
  customInclinometerIcon,
  customIcon,
  customShadowIcon,
  customInclinometerShadowIcon,
  inclinometers,
  open,
  mode,
  assetSubs,
  setAssetSubs,
  errors,
  setErrors,
  BootstrapButton,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [mapType] = useState("regular");
  const initializedRef = useRef(false);
  const [substructureAsignToggle, setSubstructureAsignToggle] = useState(false);
  const [substructureDataToggle, setSubstructureDataToggle] = useState([]);
  const [substructureSectionToggle, setSubstructureSectionToggle] = useState([]);
  const [substructureSectionDataToggle, setSubstructureSectionDataToggle] = useState([]);

  const [inclinometerShadowIndex, setInclinometerShadowIndex] = useState(null);

  useMemo(() => {
    const newEquipments = [...equipment];
    const updatedEquipment = { ...newEquipments[indexEquipment] };
    const actualLength = updatedEquipment.channels[indChan].substructures.length;

    const newSubAsign = [];
    const newSectionAsign = [];
    const newSectionDataAsign = [];
    for (let indexSub = 0; indexSub < actualLength; indexSub++) {
      if (isNil(substructureDataToggle[indexSub])) {
        newSubAsign.push(false);
      } else {
        newSubAsign.push(substructureDataToggle[indexSub]);
      }
      if (
        isNil(substructureSectionToggle[indexSub]) &&
        updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
      ) {
        newSectionAsign.push(false);
      } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
        newSectionAsign.push(substructureSectionToggle[indexSub]);
      } else {
        newSectionAsign.push(null);
      }
      newSectionDataAsign.push([]);
      if (
        isNil(substructureSectionDataToggle[indexSub]) &&
        updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
      ) {
        const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          newSectionDataAsign[indexSub].push(false);
        }
      } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
        const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          if (isNil(substructureSectionDataToggle[indexSub][indexSection])) {
            newSectionDataAsign[indexSub].push(false);
          } else {
            newSectionDataAsign[indexSub].push(substructureSectionDataToggle[indexSub][indexSection]);
          }
        }
      } else {
        newSectionDataAsign.push(null);
      }
    }
    setSubstructureSectionDataToggle(newSectionDataAsign);
    setSubstructureSectionToggle(newSectionAsign);
    setSubstructureDataToggle(newSubAsign);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = (indexEquipment, indChan, channelDataToggle, setChannelDataToggle) => {
    let newChannel = clone(channelDataToggle);
    if (newChannel[indexEquipment][indChan]) {
      newChannel[indexEquipment][indChan] = false;
    } else {
      initializedRef.current = false;
      newChannel[indexEquipment][indChan] = true;
      for (let indexChannelData = 0; indexChannelData < channelDataToggle[indexEquipment].length; indexChannelData++) {
        if (indexChannelData !== indChan) {
          newChannel[indexEquipment][indexChannelData] = false;
        }
      }
    }

    setChannelDataToggle(newChannel);
  };

  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();
    if (!initializedRef.current && !isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points)) {
      map.fitBounds(polyline[0].points);
      initializedRef.current = true;
    }
    return null;
  };
  const hasChannelErrors = Object.keys(errors || {}).some((key) => key.startsWith(`channel${indChan}`));
  return (
    <>
      {hasChannelErrors ? (
        <Badge
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "red",
              color: "red",
              top: 10,
              right: 2,
            },
          }}
          badgeContent=" "
        >
          <Button
            variant="contained"
            style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
            id={`channel${indChan}_collapse`}
            onClick={() => {
              handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle);
            }}
          >
            {intl.formatMessage({ id: "channel" })} {indChan + 1}
          </Button>
        </Badge>
      ) : (
        <Button
          variant="contained"
          style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
          id={`channel${indChan}_collapse`}
          onClick={() => {
            handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle);
          }}
        >
          {intl.formatMessage({ id: "channel" })} {indChan + 1}
        </Button>
      )}

      <ThemeProvider theme={theme}>
        <Dialog
          maxWidth="lg"
          open={channelDataToggle[indexEquipment][indChan]}
          onClose={() => handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle)}
        >
          <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
            {intl.formatMessage({ id: "channel" })} {indChan + 1}
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                width: "100%",
                boxSizing: "border-box",
                overflowX: "hidden", // evita scroll horizontal
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  flex: "0 0 60%", // ocupa 60% del ancho
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  boxSizing: "border-box",
                  minWidth: 0, // importante para que los hijos flex no provoquen overflow
                  paddingRight: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    alignItems: "center",
                    width: "100%",
                    boxSizing: "border-box",
                    marginTop: "1%",
                  }}
                >
                  <TextField
                    id={`channel${indChan}_name`}
                    style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 220px" }}
                    defaultValue={e.channels[indChan].name}
                    onBlur={(ev) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channels[indChan].name = ev.target.value;
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel${indChan}_name`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.name" })}
                    required
                  />

                  <TextField
                    id={`channel${indChan}_length`}
                    style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                    disabled={true}
                    defaultValue={e.channels[indChan].info.length}
                    onBlur={(ev) => {
                      const value = parseFloat(ev.target.value);
                      const newErrors = { ...errors };
                      if (isEmpty(ev.target.value) || isNaN(value)) {
                        newErrors[ev.target.id] = "not.empty";
                      } else {
                        delete newErrors[ev.target.id];
                      }
                      setErrors(newErrors);
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channels[indChan].info.length = value;
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel${indChan}_length`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.length" })}
                    type="number"
                    required
                  />
                  {!isNil(errors[`channel${indChan}_length`]) && (
                    <ErrorText>{intl.formatMessage({ id: errors[`channel${indChan}_length`] })}</ErrorText>
                  )}
                  {e.equipmentType !== "DAS" && (
                    <React.Fragment>
                      {" "}
                      <TextField
                        id={`channel${indChan}spatial_resolution`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                        inputProps={{ min: 0 }}
                        defaultValue={e.channels[indChan].info.spatialResolution}
                        onBlur={(ev) => {
                          const value = parseFloat(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].info.spatialResolution = value;
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);
                        }}
                        error={errors[`channel${indChan}spatial_resolution`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                        required
                        type="number"
                      />{" "}
                      {!isNil(errors[`channel${indChan}spatial_resolution`]) && (
                        <ErrorText>
                          {intl.formatMessage({ id: errors[`channel${indChan}spatial_resolution`] })}
                        </ErrorText>
                      )}
                    </React.Fragment>
                  )}

                  <TextField
                    id={`channel${indChan}sampling_interval`}
                    style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                    inputProps={{ min: 0 }}
                    defaultValue={e.channels[indChan].info.samplingInterval}
                    onBlur={(ev) => {
                      const value = parseFloat(ev.target.value);
                      const newErrors = { ...errors };
                      if (isEmpty(ev.target.value) || isNaN(value)) {
                        newErrors[ev.target.id] = "not.empty";
                      } else {
                        delete newErrors[ev.target.id];
                      }
                      setErrors(newErrors);
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channels[indChan].info.samplingInterval = value;
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel${indChan}sampling_interval`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.sampling.interval" })}
                    required
                    type="number"
                  />
                  {!isNil(errors[`channel${indChan}sampling_interval`]) && (
                    <ErrorText>{intl.formatMessage({ id: errors[`channel${indChan}sampling_interval`] })}</ErrorText>
                  )}

                  {e.equipmentType !== "DAS" && (
                    <React.Fragment>
                      <TextField
                        id={`channel${indChan}_measurement_time`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                        defaultValue={e.channels[indChan].measurement.measurementTime}
                        inputProps={{ min: 0 }}
                        onBlur={(ev) => {
                          const value = parseFloat(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].measurement.measurementTime = value;
                          const suma = updatedEquipment.channels.reduce(
                            (acumulador, canal) => acumulador + (parseFloat(canal.measurement.measurementTime) || 0),
                            0,
                          );
                          updatedEquipment.measurementInfo.interval = suma;
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);

                          let newInter = clone(equipmentInterMeasurement);
                          newInter[indexEquipment] = suma;
                          setEquipmentInterMeasurement(newInter);
                        }}
                        error={errors[`channel${indChan}_measurement_time`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.measurement.time" })}
                        required
                        type="number"
                      />{" "}
                      {!isNil(errors[`channel${indChan}_measurement_time`]) && (
                        <ErrorText>
                          {intl.formatMessage({ id: errors[`channel${indChan}_measurement_time`] })}
                        </ErrorText>
                      )}
                    </React.Fragment>
                  )}

                  {e.equipmentType === "DAS" && (
                    <>
                      <TextField
                        id={`channel${indChan}acquisition_frequency`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                        defaultValue={e.channels[indChan].info.acquisitionFrequency}
                        inputProps={{
                          min: 0,
                          ...(e.equipmentType === "DAS"
                            ? {
                                max:
                                  e.type === "DOUBLE"
                                    ? (parseInt(Math.ceil(1 / (2 * (channelPK[indexEquipment][indChan] * 1e-8)))) *
                                        0.95) /
                                      2
                                    : parseInt(Math.ceil(1 / (2 * (channelPK[indexEquipment][indChan] * 1e-8)))) * 0.95,
                              }
                            : {}),
                        }}
                        onBlur={(ev) => {
                          const max =
                            e.type === "DOUBLE"
                              ? (parseInt(Math.ceil(1 / (2 * (channelPK[indexEquipment][indChan] * 1e-8)))) * 0.95) / 2
                              : parseInt(Math.ceil(1 / (2 * (channelPK[indexEquipment][indChan] * 1e-8)))) * 0.95;
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(ev.target.value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else if (e.equipmentType === "DAS" && parseFloat(ev.target.value) > max) {
                            newErrors[ev.target.id] = "max.value.surpassed";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].info.acquisitionFrequency = parseFloat(ev.target.value);
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);
                        }}
                        error={errors[`channel${indChan}acquisition_frequency`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.acquisition.frequency" })}
                        required
                        type="number"
                      />
                      {!isNil(errors[`channel${indChan}acquisition_frequency`]) && (
                        <ErrorText>
                          {intl.formatMessage({ id: errors[`channel${indChan}acquisition_frequency`] })}
                        </ErrorText>
                      )}
                      <TextField
                        id={`channel${indChan}_gauge_length`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                        defaultValue={e.channels[indChan].info.gaugeLength}
                        inputProps={{ min: 0 }}
                        onBlur={(ev) => {
                          const value = parseFloat(ev.target.value);
                          const newErrors = { ...errors };
                          if (isEmpty(ev.target.value) || isNaN(value)) {
                            newErrors[ev.target.id] = "not.empty";
                          } else {
                            delete newErrors[ev.target.id];
                          }
                          setErrors(newErrors);
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].info.gaugeLength = value;
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);
                        }}
                        error={errors[`channel_gauge_length_${indChan}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.gauge.length" })}
                        required
                        type="number"
                      />
                      {!isNil(errors[`channel_gauge_length_${indChan}`]) && (
                        <ErrorText>{intl.formatMessage({ id: errors[`channel_gauge_length_${indChan}`] })}</ErrorText>
                      )}
                    </>
                  )}
                  <div
                    style={{
                      marginLeft: "auto",
                      minWidth: 0,
                      flexBasis: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id={`channel${indChan}_checkbox`}
                          sx={{
                            color: palette.primary,
                            "&.Mui-checked": {
                              color: palette.primary,
                            },
                          }}
                          defaultChecked={e.channels[indChan].measurement.state}
                          onChange={(ev) => {
                            handleChannelDisability({
                              actualID: equipment + indexEquipment + "_frequency",
                              equipment,
                              equipmentInterMeasurement,
                              errors,
                              indChan,
                              indexEquipment,
                              newState: ev.target.checked,
                              setEquipment,
                              setEquipmentInterMeasurement,
                              setErrors,
                            });
                          }}
                        />
                      }
                      label={intl.formatMessage({ id: "disable?" })}
                    />
                    {e.channels[indChan].measurement.state ? (
                      <TextField
                        id={`channel${indChan}_info`}
                        style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 300px" }}
                        inputProps={{ min: 0 }}
                        defaultValue={e.channels[indChan].info.desc}
                        onBlur={(ev) => {
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].info.desc = ev.target.value;
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);
                        }}
                        error={errors[`channel${indChan}_info`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.info" })}
                      />
                    ) : null}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <TextField
                    id={`channel${indChan}sub_quantity`}
                    style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                    defaultValue={e.channels[indChan].substructures.length}
                    value={e.channels[indChan].substructures.length}
                    inputProps={{ min: 0 }}
                    onChange={(ev) => {
                      const value = parseFloat(ev.target.value);
                      const newErrors = { ...errors };
                      if (isEmpty(ev.target.value) || isNaN(value)) {
                        newErrors[ev.target.id] = "not.empty";
                      } else {
                        delete newErrors[ev.target.id];
                      }
                      setErrors(newErrors);
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      let newZoneSubToggle = clone(zoneSubToggle);
                      newZoneSubToggle[indexEquipment][indChan] = [];
                      let newZoneToggle = clone(zoneToggle);
                      const newLength = parseInt(ev.target.value);
                      const actualLength = updatedEquipment.channels[indChan].substructures.length;
                      if (newLength > actualLength) {
                        for (let i = actualLength; i < newLength; i++) {
                          updatedEquipment.channels[indChan].substructures.push("");
                          //if (!isEmpty(polylineDisplay) && !moreSubsAllowed) {
                          //  updatedEquipment.channels[indChan].substructures.push({
                          //    name: "",
                          //    type: "generic",
                          //    polyline: 0,
                          //    depth: null,
                          //    sections: null,
                          //    zones: [],
                          //    ref: "",
                          //    equipmentBehavior: equipment[indexEquipment].equipmentType === "A-DTS" ? "A-DTS" : null,
                          //  });
                          //} else {
                          //  updatedEquipment.channels[indChan].substructures.push({
                          //    name: "",
                          //    type: "inclinometer",
                          //    polyline: [0, 0],
                          //    depth: 50,
                          //    sections: [""],
                          //    zones: [],
                          //    ref: "",
                          //    equipmentBehavior: equipment[indexEquipment].equipmentType === "A-DTS" ? "A-DTS" : null,
                          //  });
                          //}
                        }
                      } else {
                        updatedEquipment.channels[indChan].substructures.splice(newLength);
                      }
                      const newSubAsign = [];
                      const newSectionAsign = [];
                      const newSectionDataAsign = [];

                      for (let indexSub = 0; indexSub < newLength; indexSub++) {
                        newZoneSubToggle[indexEquipment][indChan].push(false);
                        if (isNil(zoneToggle[indexEquipment]?.[indChan]?.[indexSub])) {
                          newZoneToggle[indexEquipment] ??= [];
                          newZoneToggle[indexEquipment][indChan].push([]);
                          newZoneToggle[indexEquipment][indChan][indexSub].push(false);
                        }

                        if (isNil(substructureDataToggle[indexSub])) {
                          newSubAsign.push(false);
                        } else {
                          newSubAsign.push(substructureDataToggle[indexSub]);
                        }
                        if (
                          isNil(substructureSectionToggle[indexSub]) &&
                          updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
                        ) {
                          newSectionAsign.push(false);
                        } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
                          newSectionAsign.push(substructureSectionToggle[indexSub]);
                        } else {
                          newSectionAsign.push(null);
                        }
                        newSectionDataAsign.push([]);
                        if (
                          isNil(substructureSectionDataToggle[indexSub]) &&
                          updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
                        ) {
                          const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
                          for (let indexSection = 0; indexSection < secCount; indexSection++) {
                            newSectionDataAsign[indexSub].push(false);
                          }
                        } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
                          const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
                          for (let indexSection = 0; indexSection < secCount; indexSection++) {
                            if (isNil(substructureSectionDataToggle[indexSub][indexSection])) {
                              newSectionDataAsign[indexSub].push(false);
                            } else {
                              newSectionDataAsign[indexSub].push(substructureSectionDataToggle[indexSub][indexSection]);
                            }
                          }
                        } else {
                          newSectionDataAsign.push(null);
                        }
                      }

                      if (newZoneToggle[indexEquipment] && newZoneToggle[indexEquipment][indChan]) {
                        newZoneToggle[indexEquipment][indChan] = newZoneToggle[indexEquipment][indChan].slice(
                          0,
                          newLength,
                        );
                      }

                      setZoneToggle(newZoneToggle);
                      setZoneSubToggle(newZoneSubToggle);
                      setSubstructureSectionDataToggle(newSectionDataAsign);
                      setSubstructureSectionToggle(newSectionAsign);
                      setSubstructureDataToggle(newSubAsign);
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel${indChan}sub_quantity`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "sub.count" })}
                    required
                    type="number"
                  />
                  {!isNil(errors[`channel${indChan}sub_quantity`]) && (
                    <ErrorText>{intl.formatMessage({ id: errors[`channel${indChan}sub_quantity`] })}</ErrorText>
                  )}
                  <BootstrapButton
                    variant="contained"
                    style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                    id={`substructures-to-channels${indChan}`}
                    onClick={() => {
                      let newChannel = clone(substructureAsignToggle);
                      if (newChannel) {
                        newChannel = false;
                      } else {
                        newChannel = true;
                      }
                      setSubstructureAsignToggle(newChannel);
                    }}
                  >
                    {intl.formatMessage({ id: "substructures.to.polylines" })}
                    {!substructureAsignToggle ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                  </BootstrapButton>
                  <Collapse in={substructureAsignToggle}>
                    {e.channels[indChan].substructures.map((sub, indSub) => {
                      const indexAssetSub = assetSubs.findIndex(
                        (as) => e.channels[indChan].substructures[indSub] === as.ref,
                      );
                      if (indexAssetSub < 0) {
                        return (
                          <>
                            <h1
                              style={{ marginRight: "1%" }}
                              id={`channel${indChan}sub${indSub}_collapse`}
                              onClick={() => {
                                let newChannel = clone(substructureDataToggle);
                                if (newChannel[indSub]) {
                                  newChannel[indSub] = false;
                                } else {
                                  newChannel[indSub] = true;
                                }
                                setSubstructureDataToggle(newChannel);
                              }}
                            >
                              {intl.formatMessage({ id: "sub" })} {indSub + 1}
                              {!substructureDataToggle[indSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                            </h1>
                            <Collapse in={substructureDataToggle[indSub]}>
                              <div
                                key={`substructure_${indSub}`}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  width: "100%",
                                  boxSizing: "border-box",
                                  marginTop: "2%",
                                  flexWrap: "wrap",
                                }}
                              >
                                <TextField
                                  id={`channel${indChan}sub__${indSub}`}
                                  variant="outlined"
                                  //disabled={!moreSubsAllowed}
                                  style={{ width: "15rem", minWidth: 0 }}
                                  label={intl.formatMessage({ id: "sub.type" })}
                                  value={e.channels[indChan].substructures[indSub]}
                                  select
                                  onChange={(ev) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.channels[indChan].substructures[indSub] = ev.target.value;

                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                    setHoveredPolylineIndex(null);
                                    setInclinometerShadowIndex(null);
                                  }}
                                  error={errors[`selection_sub`] ? true : false}
                                  required
                                >
                                  {assetSubs.map((assu, assuIndex) => {
                                    if (assu.type === "generic" && channelPK[indexEquipment][indChan] === 0)
                                      return null;
                                    return (
                                      <MenuItem
                                        key={`selection_sub_${assu.name}`}
                                        value={`${assu.ref}`}
                                        onMouseOver={() => {
                                          setHoveredPolylineIndex(null);
                                          setInclinometerShadowIndex(null);
                                          if (assu.type === "generic") {
                                            setTimeout(() => {
                                              const realIndex = polylineDisplay.findIndex(
                                                (poly) =>
                                                  poly.id === assu.polyline && e.equipmentType === poly.equipment_type,
                                              );
                                              setHoveredPolylineIndex(realIndex);
                                            }, 0);
                                          } else {
                                            console.log(inclinometers);
                                            const realIndex = inclinometers.findIndex(
                                              (incli) => incli === assu.polyline,
                                            );
                                            setTimeout(() => {
                                              setInclinometerShadowIndex(realIndex);
                                            }, 0);
                                          }
                                        }}
                                        onMouseOut={() => {
                                          setHoveredPolylineIndex(null);
                                          setInclinometerShadowIndex(null);
                                        }}
                                        onClick={() => {
                                          setHoveredPolylineIndex(null);
                                          setInclinometerShadowIndex(null);
                                        }}
                                      >
                                        {assu.name}
                                      </MenuItem>
                                    );
                                  })}
                                </TextField>
                              </div>
                            </Collapse>
                          </>
                        );
                      }
                      return (
                        <>
                          <h1
                            style={{ marginRight: "1%" }}
                            id={`channel${indChan}sub${indSub}_collapse`}
                            onClick={() => {
                              let newChannel = clone(substructureDataToggle);
                              if (newChannel[indSub]) {
                                newChannel[indSub] = false;
                              } else {
                                newChannel[indSub] = true;
                              }
                              setSubstructureDataToggle(newChannel);
                            }}
                          >
                            {intl.formatMessage({ id: "sub" })} {indSub + 1}
                            {!substructureDataToggle[indSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                          </h1>
                          <Collapse in={substructureDataToggle[indSub]}>
                            <div
                              key={`substructure_${indSub}`}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "0.5rem",
                                width: "100%",
                                boxSizing: "border-box",
                                marginTop: "2%",
                                flexWrap: "wrap",
                              }}
                            >
                              <TextField
                                id={`channel${indChan}sub__${indSub}`}
                                variant="outlined"
                                //disabled={!moreSubsAllowed}
                                style={{ width: "15rem", minWidth: 0 }}
                                label={intl.formatMessage({ id: "sub.type" })}
                                value={e.channels[indChan].substructures[indSub]}
                                select
                                onChange={(ev) => {
                                  const newEquipments = [...equipment];
                                  const updatedEquipment = { ...newEquipments[indexEquipment] };
                                  updatedEquipment.channels[indChan].substructures[indSub] = ev.target.value;

                                  newEquipments[indexEquipment] = updatedEquipment;
                                  setEquipment(newEquipments);
                                  setHoveredPolylineIndex(null);
                                  setInclinometerShadowIndex(null);
                                }}
                                error={errors[`selection_sub`] ? true : false}
                                required
                              >
                                {assetSubs.map((assu, assuIndex) => {
                                  if (assu.type === "generic" && channelPK[indexEquipment][indChan] === 0) return null;
                                  return (
                                    <MenuItem
                                      key={`selection_sub_${assu.name}`}
                                      value={`${assu.ref}`}
                                      onMouseOver={() => {
                                        setHoveredPolylineIndex(null);
                                        setInclinometerShadowIndex(null);
                                        if (assu.type === "generic") {
                                          setTimeout(() => {
                                            const realIndex = polylineDisplay.findIndex(
                                              (poly) =>
                                                poly.id === assu.polyline && e.equipmentType === poly.equipment_type,
                                            );
                                            setHoveredPolylineIndex(realIndex);
                                          }, 0);
                                        } else {
                                          console.log(inclinometers);
                                          const realIndex = inclinometers.findIndex((incli) => incli === assu.polyline);
                                          setTimeout(() => {
                                            setInclinometerShadowIndex(realIndex);
                                          }, 0);
                                        }
                                      }}
                                      onMouseOut={() => {
                                        setHoveredPolylineIndex(null);
                                        setInclinometerShadowIndex(null);
                                      }}
                                      onClick={() => {
                                        setHoveredPolylineIndex(null);
                                        setInclinometerShadowIndex(null);
                                      }}
                                    >
                                      {assu.name}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>

                              {equipment[indexEquipment].equipmentType === "A-DTS" && (
                                <Tooltip
                                  title={
                                    <React.Fragment>
                                      <Typography color="inherit">
                                        {intl.formatMessage({ id: "sub.behavior" })}
                                      </Typography>
                                    </React.Fragment>
                                  }
                                  placement="right"
                                >
                                  <TextField
                                    id={`channel${indChan}sub_behavior_${indSub}`}
                                    variant="outlined"
                                    //disabled={!moreSubsAllowed}
                                    style={{ width: "5rem", minWidth: 0 }}
                                    label={intl.formatMessage({ id: "sub.behavior" })}
                                    value={assetSubs[indexAssetSub].equipmentBehavior}
                                    select
                                    onChange={(ev) => {
                                      let newAssetSubs = clone(assetSubs);
                                      newAssetSubs[indexAssetSub].equipmentBehavior = ev.target.value;
                                      setAssetSubs(newAssetSubs);
                                    }}
                                    error={errors[`channel${indChan}sub_behavior_${indSub}`] ? true : false}
                                    required
                                  >
                                    <MenuItem key={`channel${indChan}sub_behavior_${indSub}_A-DTS"`} value={"A-DTS"}>
                                      A-DTS
                                    </MenuItem>
                                    <MenuItem key={`channel${indChan}sub_behavior_${indSub}_DTSS`} value={"DTS"}>
                                      DTSS
                                    </MenuItem>
                                  </TextField>
                                </Tooltip>
                              )}
                            </div>
                          </Collapse>
                        </>
                      );
                    })}
                  </Collapse>
                </div>
              </div>

              <div
                style={{
                  flex: "0 0 40%", // ocupa el 40% restante
                  minWidth: "320px",
                  boxSizing: "border-box",
                  height: "calc(100vh - 320px)",
                }}
              >
                <MapContainer
                  id="map-equipment-id"
                  center={[43, 0]}
                  zoom={5}
                  style={{ height: "100%", width: "100%" }}
                  anima
                  rotateControl={false}
                >
                  <TileLayer
                    attribution={window.RUNTIME_CONFIG.IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
                    url={window.RUNTIME_CONFIG.MAP_TYPES.find((type) => type.value === mapType).tileLayer}
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                  />
                  {centroid.length > 0 && (
                    <Marker key={"Centroid"} position={centroid} icon={customCentroidIcon}></Marker>
                  )}
                  <MyComponentSetView polyline={polylineDisplay} />
                  {/* polylines / markers (misma lógica tua) */}
                  {isNil(hoveredPolylineIndex) &&
                    polylineDisplay.length > 0 &&
                    polylineDisplay.map((polyline, index) => {
                      if (polyline.equipment_type !== e.equipmentType) return null;
                      let color = "black";
                      // eslint-disable-next-line array-callback-return
                      return polyline.points.map((point, indice) => {
                        if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) return null;
                        if (polyline.must_graph_points.includes(indice)) {
                          const previousIndex =
                            polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                          const center = [
                            [
                              polylineDisplay[index].points[previousIndex].lat,
                              polylineDisplay[index].points[previousIndex].lng,
                            ],
                            [point.lat, point.lng],
                          ];
                          for (let indexSub = 0; indexSub < e.channels[indChan].substructures.length; indexSub++) {
                            const indexAssetSub = assetSubs.findIndex(
                              (as) => e.channels[indChan].substructures[indexSub] === as.ref,
                            );
                            if (indexAssetSub >= 0 && index === assetSubs[indexAssetSub].polyline) {
                              color = "red";
                            }
                          }
                          return <Polyline key={indice + "_" + index} color={color} positions={center} weight={5} />;
                        }
                      });
                    })}

                  {!isNil(hoveredPolylineIndex) &&
                    polylineDisplay.length > 0 &&
                    polylineDisplay.map((polyline, index) => {
                      if (polyline.equipment_type !== e.equipmentType) return null;
                      let color = "black";
                      // eslint-disable-next-line array-callback-return
                      return polyline.points.map((point, indice) => {
                        if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) return null;
                        if (polyline.must_graph_points.includes(indice)) {
                          const previousIndex =
                            polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                          const center = [
                            [
                              polylineDisplay[index].points[previousIndex].lat,
                              polylineDisplay[index].points[previousIndex].lng,
                            ],
                            [point.lat, point.lng],
                          ];
                          for (let indexSub = 0; indexSub < e.channels[indChan].substructures.length; indexSub++) {
                            const indexAssetSub = assetSubs.findIndex(
                              (as) => e.channels[indChan].substructures[indexSub] === as.ref,
                            );
                            if (indexAssetSub >= 0 && index === assetSubs[indexAssetSub].polyline) {
                              color = "red";
                            }
                          }
                          return (
                            <Polyline
                              key={indice + "_" + index}
                              color={hoveredPolylineIndex === index ? "#0dff00" : color}
                              positions={center}
                              weight={hoveredPolylineIndex === index ? 9 : 5}
                            />
                          );
                        }
                      });
                    })}

                  {equipment.length > 0 &&
                    equipment.map((equip, index) => (
                      <Marker
                        key={"equipment" + index}
                        position={[equip.latitude, equip.longitude]}
                        icon={open[index] ? customShadowIcon : customIcon}
                      />
                    ))}

                  {inclinometers.length > 0 &&
                    inclinometers.map((im, incliIndex) => (
                      <Marker
                        key={"inclinometer" + incliIndex + im}
                        position={im}
                        icon={
                          incliIndex === inclinometerShadowIndex ? customInclinometerShadowIcon : customInclinometerIcon
                        }
                      />
                    ))}
                </MapContainer>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: palette.secondary, color: "white" }}
              onClick={() => handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle)}
            >
              {intl.formatMessage({ id: "accept" })}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ModalChannelInfo;
